import { render, staticRenderFns } from "./UserTeam.vue?vue&type=template&id=b722dce8&scoped=true&"
import script from "./UserTeam.vue?vue&type=script&lang=js&"
export * from "./UserTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b722dce8",
  null
  
)

export default component.exports